import EmberRouter from '@ember/routing/router';
import config from 'e-commerce/config/environment';
import { setupRouterTracking } from 'beebee-base/lib/router-tracking';

import { inject as service } from '@ember/service';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;

  @service router;

  constructor() {
    super(...arguments);
    setupRouterTracking(this, {
      gaId: 'G-Q4R8QL4WC0',
      stripToken: true,
      pushDataLayer: true,
      scrollSelector: 'html, body',
      scrollDuration: 50,
      dropdownCleanup: false,
    });
  }
}

Router.map(function () {
  this.route('confirm');
  this.route('user');
  this.route('list');
  this.route('gift');
  this.route('checkout');

  this.route('private');

  this.route('payment_status', {
    path: '/payment_status/:id',
  });
  this.route('404');
  this.route('payment-request');
  this.route('detail', {
    path: '/detail/:id',
  });

  this.route('ski-instructor', {
    path: '/ski-instructor/:id',
  });

  this.route('checkin');

  this.route('token_login', {
    path: '/token_login/:state/:token',
  });
});
